import { render, staticRenderFns } from "./PurpleSpace.vue?vue&type=template&id=721df7b1&scoped=true&"
import script from "./PurpleSpace.vue?vue&type=script&lang=js&"
export * from "./PurpleSpace.vue?vue&type=script&lang=js&"
import style0 from "./PurpleSpace.vue?vue&type=style&index=0&id=721df7b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721df7b1",
  null
  
)

export default component.exports